const analytics = {
  event: event => {
    if (window.gtag) {
      window.gtag('event', {
        event_category: event.category,
        event_label: event.action,
      });
    }
  },
};

export default analytics;
